import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Card } from './Card';
import { Skeleton } from './Skeleton';

interface StatTileProps {
  label: string;
  /** The big value: a string, or a <Money> element. `undefined` shows a loading skeleton. */
  value: ReactNode;
  /** Optional secondary line (e.g. a comparison). */
  detail?: ReactNode;
  tone?: 'default' | 'warning' | 'danger' | 'success';
  /** The tile is inside a link: give it hover feedback. */
  interactive?: boolean;
  className?: string;
}

const valueTone = { default: 'text-ink', warning: 'text-wait', danger: 'text-bad', success: 'text-ok' };

export const StatTile = ({ label, value, detail, tone = 'default', interactive, className }: StatTileProps) => (
  <Card
    className={cn(
      'h-full px-4 py-4 sm:px-5',
      tone === 'warning' && 'border-wait/40',
      interactive && 'transition-colors hover:border-brand',
      className
    )}
  >
    <p className="text-label font-medium text-muted">{label}</p>
    <div className={cn('mt-1 text-title font-semibold tabular-nums', valueTone[tone])}>
      {value === undefined ? <Skeleton className="mt-2 h-6 w-24" /> : value}
    </div>
    {detail && <p className="mt-1 text-label text-muted">{detail}</p>}
  </Card>
);
